// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'
import axios from 'axios'
import config from "./js/config"
import 'babel-polyfill'           //  支持ie浏览


// import {regionData, CodeToText, TextToCode} from 'element-china-area-data'
// import cityData from "./js/cityData"

// import XLSX from 'xlsx'
// window.XLSX = XLSX

Vue.config.productionTip = false
Vue.use(ElementUI)
axios.defaults.withCredentials = true
Vue.prototype.$axios = axios


/**
 * 解构赋值
 * @param {*} arr1 key
 * @param {*} arr2 value
 */
Vue.prototype.assignment = function(arr1, arr2){ //使用Element loading-start 方法
    arr1.map((item,index)  => {
        this[item] = arr2[index]
    })
}
//md5方法
import crypto from 'crypto';
Vue.prototype.$md5 = function (n) {
  let md5 = crypto.createHash("md5");
  md5.update(n);
  return md5.digest('hex');
}
// 获取uuid
Vue.prototype.guid = function(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
}

// 计算文件大小
Vue.prototype.getSize = (num) =>{
    let unit = 'KB'
    num = parseInt(num * 100 / 1024) / 100
    if(num > 1024){
        num = parseInt(num * 100 / 1024) / 100
        unit = 'M'
    }
    if(num > 1024){
        num = parseInt(num * 100 / 1024) / 100
        unit = 'G'
    }
    return num + unit
}

let loading  //定义loading变量
let needLoadingRequestCount = 0
Vue.prototype.startLoading = function(){ //使用Element loading-start 方法
    if (needLoadingRequestCount === 0) {
        loading = this.$loading({
            lock: true,
            text: '加载中……',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    }
    needLoadingRequestCount++
}
Vue.prototype.endLoading = function(){ //使用Element loading-close 方法
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        if(loading) loading.close()
    }
}

//  刷新当前路由
Vue.prototype.reload = function(){
    this.$store.state.isRouterAlive = false
    this.$nextTick(() => (this.$store.state.isRouterAlive = true))
}

//  表单验证
Vue.prototype.isNull = function(rule, value, callback){
    if(value || value === 0){
        value += ''
        if(value.trim()){
            callback()
        }else{
            callback(new Error('输入不能为空'))
        }
    }else{
        callback(new Error('输入不能为空'))
    }
}

/*************************************表单验证***************************************** */
//  非负整数
Vue.prototype.isNumber = function(rule, value, callback){
    let reg = /^([1-9]\d*|[0]{1,1})$/;
    if(reg.test(value)){
        callback()
    }else{
        callback(new Error('请输入大于等于0的整数'))
    }
}
//  数字区间
Vue.prototype.betweenInt = (min, max) => (rule, v, cb) => {
    const isBetween = v >= min && v <= max
    const isInt = /^[0-9]+$/.test(v)
    if (isBetween && isInt) return cb()
    return cb(new Error(`请输入${min}~${max}的整数`))
}
//  数字（1-10个字符）
Vue.prototype.isSerialNumber = function(rule, value, callback){
    if(!value) callback()
    let reg =  /^\d{1,10}$/;
    if(reg.test(value) && value){
        callback()
    }else{
        callback(new Error('请输入数字(10个字符以内)'))
    }
}
//  数字、字母、_、.、-(1-20个字符)
Vue.prototype.isCoding = function(rule, value, callback){
    let reg =  /^[A-Za-z0-9_.]{1,20}$/;
    if(reg.test(value) && value){
        callback()
    }else{
        callback(new Error('请输入数字、字母、.、_、-(1-20个字符)'))
    }
}
//  Email
Vue.prototype.isEmail = function(rule, value, callback){
    let reg =  /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    if(reg.test(value) || !value){
        callback()
    }else{
        callback(new Error('请输入正确的邮箱'))
    }
}
//  手机号
Vue.prototype.isPhone = function(rule, value, callback){
    let reg =  /^1[0-9]{10}$/;
    if(reg.test(value) || !value){
        callback()
    }else{
        callback(new Error('请输入正确的手机号'))
    }
}
//  密码
Vue.prototype.passwordValid = function(rule, value, callback){
    let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,20}$/
    let reg1 = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,20}$/
    if(reg.test(value) && reg1.test(value)){
        callback()
    }else{
        callback(new Error("请输入8-20个字符，应包含数字、小写字母、大写字母、特殊符号4类"))
    }
}
//  座机
Vue.prototype.isTele = function(rule, value, callback){
    let reg =  /(\d{3}-\d{8}$)|(\d{4}-\d{7}$)/;
    if(reg.test(value) || !value){
        callback()
    }else{
        callback(new Error('请输入正确的座机号(用‘-’连接)'))
    }
}
//  不能为空数组
Vue.prototype.isArrayNull = function(rule, value, callback){
    if(value && value.length){
        callback()
    }else{
        callback(new Error('输入不能为空'))
    }
}
//  1~999
Vue.prototype.isPositiveNum = function(rule, value, callback){
    //  1~99
    let reg = /^[1-9][0-9]{0,2}$/;
    if(reg.test(value)){
        callback()
    }else{
        callback(new Error('请输入1~999的整数'))
    }
}


//  重置表单
Vue.prototype.resetFields = function(formName){
    this.$refs[formName].resetFields();
}

Vue.prototype.config = config         //  项目常量配置

//  获取省市区数据
// Vue.prototype.cityData = function(){
//   return cityData.data
// }

/**
 * 日期格式化
 * @param {日期} datetime
 * @param {格式化类型} fmt
 */
Vue.prototype.formatDate = function(datetime, fmt){
    var fmt = fmt || 'yyyy-MM-dd';
    var o = {
        "M+": datetime.getMonth() + 1, //月份
        "d+": datetime.getDate(), //日
        "h+": datetime.getHours(), //小时
        "m+": datetime.getMinutes(), //分
        "s+": datetime.getSeconds(), //秒
        "q+": Math.floor((datetime.getMonth() + 3) / 3), //季度
        "S": datetime.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/**
 * 返回上一页
 */
Vue.prototype.goBack = function(){
    this.$router.go(-1)
}

//  页面跳转
Vue.prototype.goRouter = function(url){
    this.$router.push(url)
}

/**
 * 将文件转化为本地路径在页面显示
 * @param {文件流对象} file
 */
Vue.prototype.getUrl = function(file){
    return file ? URL.createObjectURL(file) : null
}

/**
 * 将文件转化为本地路径在页面显示
 * @param [后台返回的字段集合] arr
 * @param "父级id" parentId
 * @param [接收树状结构数据的数组] result
 */
Vue.prototype.$getTreeDataChildren = function(arr, id, result){
    arr.map((item, index) => {
        if(item.id == id){
            let children = this.$getTreeDataChildren(arr, item.id, [])
            item.children = children
            result.push(item)
        }
    })
    return result
}

//  加载5级地址 + 装维姓名
Vue.prototype.loadWjdz = function(node, resolve, type) {
    const { level, pathNodes } = node;
    let nodes = []
    if (level == 0) {
        nodes = [{
            value: "惠城区",
            label: "惠城区",
            leaf: false
        },{
            value: "惠阳区",
            label: "惠阳区",
            leaf: false
        },{
            value: "惠东县",
            label: "惠东县",
            leaf: false
        },{
            value: "博罗县",
            label: "博罗县",
            leaf: false
        },{
            value: "龙门县",
            label: "龙门县",
            leaf: false
        },{
            value: "大亚湾",
            label: "大亚湾",
            leaf: false
        },{
            value: "仲恺区",
            label: "仲恺区",
            leaf: false
        }]
        resolve(nodes)
    } else {
        let params = {}
        pathNodes.map((item, index) => {
            index++
            params["name" + index] = item.value.split("/")[0];
        })
        if(type === 0 && level > 3){
            params.type = 0;
        }else if (level > 3 && type !== 0){
            params.type = 1;
        }
        console.log(params)
        this.$post("/api/GcgjRepairGridController/getGridAndStation", params, data => {
            console.log(data.list)
            nodes = data.list.map((item, index) => ({
                value: item.name || item.memberName + "/" + (item.memberPhone || "") + "/" + (item.workstationName || "") + "/" + (item.memberId || ""),
                label: item.name || item.memberName,
                leaf: level > 3
            }));
            resolve(nodes)
        });
    }
}

/**
 * 将地区编码转化为文字
 * @param {地区数组} arr
 */
// Vue.prototype.code2text = function(arr){
//   let area = '';
//   if(arr){
//     arr.map((code) => {
//       area += CodeToText[code]
//     })
//   }
//   return area
// },

/**
 * 对象深拷贝
 * @param {要拷贝的对象} obj
 */
Vue.prototype.deepClone = function(initalObj) {
    var obj = {};
    obj = JSON.parse(JSON.stringify(initalObj));
    return obj;
}

/**
 *
 * @param {接口名} url
 * @param {post请求参数} params
 * @param {请求成功回调} success
 * @param {请求失败回调} error
 */
Vue.prototype.$post = function(action, params, success, error) {
    let url = ''
    if(action.indexOf('http') == -1){
        url = config.httpHeadUrl + action
    }else{
        url = action
    }
    this.$axios.post(url,params).then(res => {
        this.endLoading()
        if(res.data.flag == 1){
            if(success) success(res.data)
        }else if(res.data.flag == 0){
            this.$message.error(res.data.message);
            if(error) error(res.data)
        }else if(res.data.flag == 2){
            this.$router.replace('./login')
        }
    }).catch(res=>{
        this.endLoading()
        console.log(res)
        this.$message.error("网络异常，请稍后再试！")
    })
}
//验证电话号码--非必填
global.validPhone=(rule, value,callback)=>{
    if (value!=null && value!=''){
        if(!(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/).test(value)){
            callback(new Error('请输入正确的11位手机号码'))
        }else{
            callback()
        }
    }else {
        callback()
    }
}
//验证电话号码--必填
global.validPhoneTrue=(rule, value,callback)=>{
    if (!value){
      callback(new Error('请输入电话号码'))
    }else  if (!(/^1[3|4|5|6|7|8|9][0-9]\d{8}$/).test(value)){
      callback(new Error('请输入正确的11位手机号码'))
    }else {
      callback()
    }
}
//验证只能输入数字，字母包括特殊字符
global.validAlphanumeric=(rule, value,callback)=>{
    if (value!=null && value!=''){
		if(!(/^[^\u4e00-\u9fa5]{0,}$/).test(value)){
			callback(new Error('请输入数字或字母'))
		}else{
			callback()
		}
	}else {
		callback()
	}
}
// >=0 整数
global.validInteger=(rule, value,callback)=>{
    if (value!=null && value!=''){
        if(!(/^[+]{0,1}(\d+)$/).test(value)){
            callback(new Error('请输入整数'))
        }else{
            callback()
        }
    }else {
        callback()
    }
}


/**
 *
 * @param {提示内容} text
 * @param {确定回调函数} confirmFun
 * @param {取消回调函数} cancelFun
 */
Vue.prototype._confirm = function(text, confirmFun, cancelFun){
    this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        if(confirmFun) confirmFun()
    }).catch(() => {
        if(cancelFun) cancelFun()
    });
}

//  动态title
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    setTimeout(() => {
        let menuStr = JSON.stringify(store.state.menuList)
        store.state.subActive = to.path.split('/')[1]
        if(store.state.subActive == 'login'){
            document.title = '登录';
        }else{
            if(menuStr.split('","path":"' + store.state.subActive + '"').length > 1){
                let str = menuStr.split('","path":"' + store.state.subActive + '"')[0]
                // console.log(str)
                // console.log(str.split('"parentId":null,').length -2 + '')
                // console.log(str.split('"').pop())
                document.title = str.split('name":"').pop().split('"')[0];
                store.state.pageTitle = str.split('name":"').pop().split('"')[0];
                store.state.activeIndex = str.split('"parentId":null,').length -2 + ''
                // store.state.activeIndex = config.menuList.indexOf(to.meta[0]) + ''
                localStorage.setItem("userMsg",JSON.stringify(store.state))
            }
        }
    }, 0)
    next()
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    components: { App },
    template: '<App/>',
    router,
    created: function(){
        
        // //在页面加载时读取localStorage里的状态信息
        // console.log(this.$store.replaceState(Object.assign(this.$store.state,JSON.parse(localStorage.getItem("userMsg")))))
        localStorage.getItem("userMsg") && this.$store.replaceState(Object.assign(this.$store.state,JSON.parse(localStorage.getItem("userMsg"))));
        
        // 在页面刷新时将vuex里的信息保存到localStorage里
        window.addEventListener("beforeunload",()=>{
            localStorage.setItem("userMsg",JSON.stringify(this.$store.state))
        })
    }
})



// WEBPACK FOOTER //
// ./src/main.js